import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IS_DEV } from "@/domains/main/constants/other.ts";
import { ShopTattoo, ShopTattooRemove } from "@/domains/tattooParlor/constants/tatooParlor.ts";

export interface TattooParlorState {
  isOpen: boolean;
  services: ShopTattoo;
  currentService?: ShopTattoo;
  selectedService?: ShopTattoo;
  isLoaded?: boolean;
}

const initialState: TattooParlorState = !IS_DEV
  ? {
      isOpen: false,
      services: null,
      currentService: null,
      selectedService: null,
      isLoaded: false,
    }
  : {
      isOpen: false,
      services: null,
      currentService: null,
      selectedService: null,
      isLoaded: false,
    };

const tattooParlorSlice = createSlice({
  name: "tattoo-parlor",
  initialState,
  reducers: {
    setState(state, action: PayloadAction<Partial<TattooParlorState>>) {
      return { ...state, ...action.payload };
    },
    setIsOpen(state, action: PayloadAction<boolean>) {
      state.isOpen = action.payload;
    },
    setServices(state, action: PayloadAction<ShopTattoo>) {
      state.services = action.payload;
    },
    setCurrentService(state, action: PayloadAction<ShopTattoo>) {
      state.currentService = action.payload;
    },
    setSelectedService(state, action: PayloadAction<ShopTattoo>) {
      state.selectedService = action.payload;
    },

    setIsLoaded(state, action: PayloadAction<boolean>) {
      state.isLoaded = action.payload;
    },
  },
});

export const tattooParlorReducer = tattooParlorSlice.reducer;

export const {
  setState,
  setIsOpen,
  setCurrentService,
  setServices,
  setSelectedService,
  setIsLoaded,
} = tattooParlorSlice.actions;
